import DemoBanner from "@/components/shared/DemoBanner";
import ImpersonationBanner from "@/components/shared/ImpersonationBanner";
import Flash from "@/components/Flash";
import { ConfirmProvider } from "@/components/shared/ConfirmProvider";

const pages = import.meta.glob("../pages/**/*.jsx", { eager: true });

// Every page gets the impersonation and demo banners, flash toasts and the shared
// confirmation dialog. A page that shows errors inline next to its form
// (sign-in, donations) sets `Page.inlineFlashAlerts = true` so the same
// error doesn't also pop up as a toast.
function PageWrapper({ children, inlineFlashAlerts }) {
  return (
    <ConfirmProvider>
      <ImpersonationBanner />
      <DemoBanner />
      <Flash skipAlerts={inlineFlashAlerts} />
      {children}
    </ConfirmProvider>
  );
}

// Inertia resolves the page on every visit. Build each wrapper once and
// reuse it: a new wrapper function each time is a new component type to
// React, which would remount the whole page and silently defeat
// Inertia's preserveState (form input, open panels, local state).
const resolved = new Map();

export function resolvePage(name) {
  if (resolved.has(name)) return resolved.get(name);

  const page = pages[`../pages/${name}.jsx`] || pages["../pages/Error.jsx"];
  const Component = page.default;
  const Wrapped = (props) => (
    <PageWrapper inlineFlashAlerts={Component.inlineFlashAlerts}>
      <Component {...props} />
    </PageWrapper>
  );

  Wrapped.displayName = name;
  const result = { ...page, default: Wrapped };
  resolved.set(name, result);
  return result;
}

export function inertiaTitle(title) {
  return title ? `${title} · PagePledge` : "PagePledge";
}
